import manually from 'src/assets/images/manually.svg'
import directUpload from 'src/assets/images/directUpload.svg'
import { makeStyles } from '@material-ui/core/styles'
import { useSelector } from 'react-redux'
import CloseIcon from '@mui/icons-material/Close'
import { COLORS } from 'src/utils/Themes/colors'
import keycloak from 'src/utils/commonMethods/keycloak'
import { invokeAllTypesSXP } from 'src/services/individualService'
import {
  CLIENT,
  CLIENT_SMALLCASE,
  POLICY_DOCUMENT,
} from 'src/utils/constants/Individual'

const AddExistingPolicy = (props) => {
  const classes = useStyles()
  const { closefunction, path, clientId, policyType } = props
  // use Rootstate in ts files const userInfo = useSelector((state: RootStateOrAny) => state.userInfo);
  const { userInfo } = useSelector((state) => {
    return {
      userInfo: state?.userInfo,
    }
  })

  const getClientId = () => {
    if (clientId) {
      return clientId
    }
    return userInfo?.userInfo?.userData?.mobileNumber
  }

  const sxpBody = {
    state: {
      clientId: getClientId(),
      clientType: userInfo?.userInfo?.userData?.policyHolderType,
      documentType: POLICY_DOCUMENT,
      createdBy: userInfo?.userName,
      updatedBy: userInfo?.userName,
      email: userInfo?.userInfo?.userData?.emailId,
      token: keycloak?.token,
      roles: userInfo?.userInfo?.userData?.roles,
      url: path,
      policyType: policyType,
      clientTypeUrl:
        userInfo?.userInfo?.userData?.policyHolderType === CLIENT?.CORPORATE
          ? CLIENT_SMALLCASE?.CORPORATE
          : CLIENT_SMALLCASE?.INDIVIDUAL,
    },
    userId: userInfo?.userName,
  }
  const invokeSxp = (key) => {
    invokeAllTypesSXP(sxpBody, userInfo?.userName, key)
  }

  return (
    <div className={classes.mainContainer}>
      <CloseIcon
        id='closeIcon'
        className={classes.closeIcon}
        onClick={closefunction}
      />
      <span className={classes.headerText}>
        <span>
          To upload your existing policy,
          <br />
          <span className={classes.boldHeader}>
            Choose one of the following
          </span>
        </span>
      </span>

      <div className={classes.optionsContainer}>
        <div
          className={classes.selectOption}
          onClick={() => invokeSxp('simple')}
          id='simpleUpload'
        >
          <img
            src={directUpload}
            className={classes.simpleUploadImage}
            alt={'directUpload'}
          />
          <span className={classes.selectOptionText}>
            Simply upload your policy,
            <br />
            <b>Trovity will Digitalize</b>
          </span>
        </div>
        <div className={classes.separatorContainer}>
          <div className={classes.separatorText}>OR</div>
        </div>
        <div
          className={classes.selectOption}
          onClick={() => invokeSxp('manual')}
          id='manualUpload'
        >
          <img
            src={manually}
            className={classes.manualUploadImage}
            alt={'manually'}
          />
          <span className={classes.selectOptionText}>
            Enter your policy details,
            <br />
            <b>Manually</b>
          </span>
        </div>
      </div>
    </div>
  )
}

export default AddExistingPolicy

const useStyles = makeStyles({
  mainContainer: {
    padding: '10px',
  },
  closeIcon: {
    marginLeft: '95%',
    marginTop: '1%',
    cursor: 'pointer',
    width: '20px',
    color: COLORS.MEDIUM_BLUE03,
  },
  optionsContainer: {
    width: '75%',
    margin: '3% auto',
    display: 'flex',
    justifyContent: 'center',
  },
  selectOption: {
    width: 'calc(50% - 15px)',
    textAlign: 'center',
    cursor: 'pointer',
    display: 'flex',
    flexDirection: 'column',
    gap: '5px',
    minHeight: '250px',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: COLORS.WHITE,
    borderRadius: '5px',
    '&:hover': {
      border: '0.5px solid rgba(185,34,80,0.5)',
      boxShadow:
        'rgb(0 0 0 / 20%) 0px 11px 15px -7px, rgb(0 0 0 / 14%) 0px 24px 38px 3px, rgb(0 0 0 / 12%) 0px 9px 46px 8px',
    },
  },
  separatorContainer: {
    width: '30px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    alignSelf: 'stretch',
    backgroundColor: 'rgb(238, 238, 238)',
  },
  separatorText: {
    width: '50px',
    height: '50px',
    display: 'flex',
    alignItems: 'center',
    fontWeight: 'bold',
    borderRadius: '50%',
    justifyContent: 'center',
    position: 'absolute',
    backgroundColor: 'rgb(238, 238, 238)',
  },
  simpleUploadImage: {
    width: '100px',
    flex: '1 1 80%',
    minHeight: '160px',
  },
  manualUploadImage: {
    width: '150px',
    flex: '1 1 80%',
    minHeight: '160px',
  },
  selectOptionText: {
    flex: '1 1 20%',
    minHeight: '90px',
  },
  headerText: {
    fontSize: '18px',
    textAlign: ' center',
    lineHeight: '28px',
    paddingBottom: '10px',
    color: COLORS.BLACK_NEW,
    display: 'flex',
    justifyContent: 'center',
  },
  boldHeader: {
    fontSize: '22px',
    fontWeight: 'bold',
  },
})
